import { Component, OnInit, Input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { DataService } from "src/app/data.service";

@Component({
  selector: "app-metarelatedlist",
  templateUrl: "./metarelatedlist.component.html",
  styleUrls: ["./metarelatedlist.component.scss"],
})
export class MetarelatedlistComponent implements OnInit {
  metaobjectList: any;
  @Input() buttonDropped: boolean = false;

  mode: any;
  metaobjectId: any;
  metaobjectName: any;
  metaLayoutGroupId: any;
  isLoading = false;
  isError = false;
  errorMessage = "";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      this.metaLayoutGroupId = this.route.snapshot.params.metagroupid;
    });
    this.retrieveLookupFields();
  }

  onDragStart(event: DragEvent, fields: any) {
    console.log("lookup data:", fields);

    if (fields.dropped || this.buttonDropped) {
      event.preventDefault();
      return;
    }

    event.dataTransfer.setData("application/json", JSON.stringify(fields));
  }

  retrieveLookupFields() {
    return new Promise((resolve, reject) => {
      console.log("LookupFields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`,
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`,
        ),
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName,
            fieldtype: "lookup",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getLookupFields(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res !== null && res.success == 1) {
            this.metaobjectList = res.metaobject;
            console.log(this.metaobjectList);
            // this.fields = res.data.metafields;
            // this.fieldsToDo = this.fields;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No  metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No  metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
          // this.metalayoutbutton.push(button);
        },
      );
    });
  }
}
